import {Component} from '@angular/core';
import {ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslocoDirective, TranslocoPipe} from '@jsverse/transloco';
import {Button} from 'primeng/button';
import {MessageModule} from 'primeng/message';
import {
  AbstractFormDirective,
  FormControlsConfig,
} from '../../../customer/project-sequence/chapter/chapter-8-rfq/step-8-1-proposal-parameter/components/abstract-form-directive';
import {FormFieldComponent} from '../../../../shared/components/inputs/form-field/form-field.component';
import {CountrySelectComponent} from '../../../../shared/components/inputs/country-select/country-select.component';

export interface ProviderDataFormData {
  street?: string;
  houseNumber?: string;
  zipCode?: string;
  city?: string;
  countryCode?: string;
  salesTaxNumber?: string;
  tenderContactEmail?: string;
}

@Component({
  selector: 'app-provider-data-form',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    FormFieldComponent,
    Button,
    MessageModule,
    CountrySelectComponent,
    TranslocoPipe,
  ],
  templateUrl: './provider-data-form.component.html',
})
export class ProviderDataFormComponent extends AbstractFormDirective<ProviderDataFormData> {
  private static readonly FORM_CONTROLS: FormControlsConfig<ProviderDataFormData> = {
    street: [null, {validators: [Validators.required]}],
    houseNumber: [null, {validators: [Validators.required]}],
    city: [null, {validators: [Validators.required]}],
    zipCode: [null, {validators: [Validators.required]}],
    countryCode: [null, {validators: [Validators.required]}],
    salesTaxNumber: [null, {validators: [Validators.required]}],
    tenderContactEmail: [null, {validators: [Validators.required, Validators.email]}],
  };

  constructor() {
    super(ProviderDataFormComponent.FORM_CONTROLS);
  }
}
